module.exports = __webpack_public_path__ + "media/images/front/home_video-91eb34bbc74076c2719a4964ef7917d9.mp4";